<template>
  <div class="vx-row">
    <div class="mb-4 vx-col w-full">
      <vx-card :title="ticket.title.length > 20 ? ticket.title.slice(0,17) + '...' : ticket.title">
        <template slot="actions">
          <vs-chip :color="getPriorityColor">
            <vs-avatar icon-pack="feather" icon="icon-alert-triangle" color />
            <span>Priority: {{getPriorityName}}</span>
          </vs-chip>
          <vs-chip :color="getStatusColor">
            <vs-avatar icon-pack="feather" icon="icon-info" color />
            <span>Status: {{getStatusName}}</span>
          </vs-chip>
        </template>
        <hr />
        <div class="msg-grp-container mt-3" style="min-height: 250px;">
          <h5
            class="text-center"
            style="margin-top: 2rem; margin-bottom: 3rem;"
          >Conversation Details</h5>
          <vue-perfect-scrollbar class="scroll-area">
            <div
              class="flex items-start"
              v-for="(message,index) in ticket.messages"
              :key="index"
              :class="isSender(message.sendedBy._id) === true ? 'flex-row-reverse' : ''"
            >
              <template v-if="isSender(message.sendedBy._id)">
                <vs-avatar
                  size="40px"
                  class="border-2 shadow border-solid border-white m-0 flex-shrink-0 sm:ml-5 ml-3"
                  :src="message.sendedBy.photoURL === null || message.sendedBy.photoURL === undefined ? require('@/assets/images/portrait/small/avatar.svg') : getImage(message.sendedBy.photoURL)"
                ></vs-avatar>

                <div
                  class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-xl bg-gray-800 text-white"
                >
                  <p style="margin-bottom: 10px;">{{message.message}}</p>
                  <vs-chip class="float-right" style="font-size: 10px;" color="dark">
                    <vs-avatar icon-pack="feather" icon="icon-calendar" color />
                    {{message.date | moment('from', 'now')}}
                  </vs-chip>
                </div>
              </template>
              <template v-else>
                <vs-avatar
                  size="40px"
                  class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                  :src="message.sendedBy.photoURL === null || message.sendedBy.photoURL === undefined ? require('@/assets/images/portrait/small/avatar.svg') : getImage(message.sendedBy.photoURL)"
                ></vs-avatar>
                <div
                  class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-xl ml-3"
                >
                  <p style="margin-bottom: 10px;">{{message.message}}</p>
                  <vs-chip style="font-size: 10px;" color="dark">
                    <vs-avatar icon-pack="feather" icon="icon-calendar" color />
                    {{message.date | moment('from', 'now')}}
                  </vs-chip>
                </div>
              </template>
            </div>
          </vue-perfect-scrollbar>
        </div>
        <div class="chat__input flex p-4 bg-white">
          <vs-input
            class="flex-1"
            placeholder="Type Your Message"
            v-model="new_message"
            @keyup.enter="sendMessage"
          />
          <vs-button class="bg-primary-gradient ml-4" type="filled" @click="sendMessage">Send</vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      ticket: {
        title: '',
        priority: 0,
        status: 0,
        messages: []
      },
      new_message: ''
    }
  },
  computed: {
    getPriorityName () {
      switch (this.ticket.priority) {
      case 3:
        return 'High'
      case 2:
        return 'Medium'
      case 1:
        return 'Low'
      default:
        return 'Unspecified'
      }
    },
    getPriorityColor () {
      switch (this.ticket.priority) {
      case 3:
        return 'danger'
      case 2:
        return 'warning'
      case 1:
        return 'success'
      default:
        return 'dark'
      }
    },
    getStatusName () {
      switch (this.ticket.status) {
      case 1:
        return 'Open'
      case 0:
        return 'Closed'
      }
    },
    getStatusColor () {
      switch (this.ticket.status) {
      case 1:
        return 'success'
      case 0:
        return 'danger'
      }
    }
  },
  methods: {
    sendMessage () {
      this.$http
        .put('/user/tickets', {
          _id: this.$route.params.id,
          message: this.new_message
        })
        .then(res => {
          this.new_message = ''
          if (res.data.status === true) {
            this.getTicketDetail()
            this.$swal({
              position: 'bottom-start',
              icon: 'success',
              toast: true,
              title: res.data.message,
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true
            })
          }
        })
        .catch(err => {
          this.$swal({
            position: 'bottom-start',
            icon: 'error',
            toast: true,
            title: err.response.data.message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          })
        })
    },
    getTicketDetail () {
      this.$http
        .get('/user/tickets', { params: { id: this.$route.params.id } })
        .then(res => {
          if (res.data.status === true) {
            this.ticket = res.data.ticket
          }
        })
    },
    getImage (image_id) {
      return `${process.env.VUE_APP_BASE_URL}/images/${image_id}`
    },
    isSender (user_id) {
      if (user_id === this.$store.state.AppActiveUser._id) {
        return true
      }
      return false
    }
  },
  created () {
    this.getTicketDetail()
  }
}
</script>

<style lang="scss">
.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
}
</style> 